export default "__VITE_ASSET__p3MJ0nLK__"